import { Routes } from '@angular/router';
import {
  AuthComponent,
  DashboardComponent,
  DevicesComponent,
  RuleManagementComponent,
  ServersPage,
  SettingsComponent,
  SubscriptionComponent,
  RechargeComponent,
  WebLayoutComponent,
  ExtensionLayoutComponent,
  HomeComponent,
  ChatwootComponent,
  InvoiceStatus,
  ForgotPasswordComponent,
} from 'web-ui';
import { authGuard } from './auth.guard';
import { environment } from '../environments/environment';

const isExtension = () => environment.buildTarget === 'extension';

const getTargetLayout = () => {
  return isExtension() ? ExtensionLayoutComponent : WebLayoutComponent;
};

const commonPaths: Routes = [
  {
    path: 'users',
    children: [
      {
        path: '',
        redirectTo: 'signin',
        pathMatch: 'full',
      },
      {
        path: 'signin',
        component: AuthComponent,
      },
      {
        path: "signup",
        component: AuthComponent,
      },
      {
        path: "forgot",
        component: AuthComponent,
      }
      // {
      //   path: '**',
      //   redirectTo: 'signin',
      //   pathMatch: 'full',
      // },
      // {
      //   path: "signup-verify",
      //   component: SignupVerifyComponent,
      // },
      // {
      //   path: "forget-password",
      //   component: ForgetPasswordComponent,
      // },
      // {
      //   path: "forget-password-verify",
      //   component: ForgetPasswordVerifyComponent,
      // },
      // {
      //   path: "redirect",
      //   component: RedirectComponent,
      // },
    ],
  },
  {
    path: 'invoices',
    component: RechargeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'cs',
    component: ChatwootComponent
  },
  {
    path: 'subscription',
    component: SubscriptionComponent,
  },
  {
    path: 'status',
    component: InvoiceStatus,
  }
];

const extensionPaths: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'device',
    component: DevicesComponent,
  },
  {
    path: 'settings',
    component: SettingsComponent,
  },
  {
    path: 'servers',
    component: ServersPage,
    canActivate: [authGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'rules-management',
    component: RuleManagementComponent,
  },
];

const webPaths: Routes = [
  {
    path: '**',
    redirectTo: 'services',
    pathMatch: 'full',
  },
  {
    path: 'services',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },

    ],
  },
];

const getPaths = (): Routes => (isExtension() ? [...commonPaths, ...extensionPaths] : [...commonPaths, ...webPaths]);

export const routes: Routes = [
  {
    path: '',
    component: getTargetLayout(),
    children: getPaths(),
  },
  {
    path: '**',
    redirectTo: isExtension() ? 'home' : 'services',
    pathMatch: 'full',
  },
];
